export const routes = {
  HOME: "/",
  CAPABILITIES: "/node/capabilities/*",
  SOLUTIONS: "/node/solutions/*",
  FUNCTIONAL: "/node/functional/*",
  CLIENT: "/node/client/*",
  VIEW_PDF: "/view-pdf/*",
  SEARCH: "/search",
  NODE: "/node/:parentPath/*",
};
